export default __webpack_public_path__ + "static/media/h.4fb16421.jpg";